// extracted by mini-css-extract-plugin
module.exports = {"page":"layout_page__znzw3","content":"layout_content__ehK9O","contain":"layout_contain__KRZRf","pageTop":"layout_pageTop__Xr2gp","contentTop":"layout_contentTop___b6w4"};